import {
  IField,
  IFormDocument,
  IList,
  SELECTED_ITEMS_KEY,
} from 'app/services/api5-service/api.interface';

import { filterNotDefinedItems } from 'utils/filter-not-defined-items';

import { HiddenControlWithValue } from '../input';
import { TypedControlBase } from '../typed-controls';

export interface ListControl extends TypedControlBase {
  readonly control: IList;
  readonly type: 'list';
}

/**
 * Map control metadata to typed object
 *
 * @param field - field metadata
 * @param doc
 */
export function getTypeControlsForList(
  field: IField,
  doc: IFormDocument,
): (HiddenControlWithValue | ListControl)[] {
  const control = field.list?.[0];

  const list: ListControl | undefined = control
    ? ({
        control: control,
        type: 'list',
      } as ListControl)
    : undefined;

  let selectedItems: HiddenControlWithValue | undefined;
  if (control?.$type === 'selectable') {
    const listOptions = doc.list?.find(
      options => options.$name === control.$name,
    );

    if (listOptions) {
      // 'selectable' list ASSUME, that FE will add selected ids to any request on BE
      // in order to do this create fake hidden input in order to easily control selected items in form model
      // so all requests will contain selected items ids
      selectedItems = {
        control: {
          $name: SELECTED_ITEMS_KEY,
          $type: 'hidden',
        },
        value: listOptions.$selected || '',
        type: 'hidden',
      } as HiddenControlWithValue;
    }
  }

  // @TODO i.ablov parse list controls here!
  return filterNotDefinedItems([selectedItems, list]);
}
